import styled from "styled-components";

export const GaihanWrapper = styled.div`
  min-width: 435px;
  min-height: 410px;
  box-sizing: border-box;
  font-weight: 500;
`;

export const GaihanFormContent = styled.div`
  margin-top: 3rem;
  box-shadow: 6px 6px 60px rgba(3, 13, 99, 0.08);
  border-radius: 24px;
  background: #D0CFD3;
  width: 100%;
  padding: 2rem 3rem;
  font-weight: 500;

  p, h2 {
    color: ${({ theme }) => theme.textDarkBlue};
    font-weight: 500;
  }

  p {
    font-size: 14px;
    margin-bottom: 0;
  }

  label {
    color: ${({ theme }) => theme.textGrey};
    font-size: 14px;
    font-weight: 500;
  }

  button {
    font-size: 14px;
    font-weight: 500;
    height: 40px;
  }

  input {
    font-size: 14px;
    font-weight: 500;
  }

  input::placeholder {
    color: #DFE0F0;
    font-size: 14px;
    font-weight: 500;
  }

  .btn_login-new {
    background: #E37713;
    border-radius: 24px;
    outline: none;
    border: none;
  }

  .btn_logout {
    background: #6c757d;
    border-radius: 24px;
    outline: none;
    border: none;
  }

  .teacher-info {
    font-size: 13px;
    color: #555;
    margin-bottom: 10px;
    padding: 5px 10px;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 8px;
  }

  .error-message {
    color: #c93434;
    font-size: 13px;
    margin-top: 5px;
    font-weight: 500;
  }
`;
